<template>
    <div class="modal-add-address">
        <div class="main-modal">
            <div class="close" @click="$parent.close()">
                <b-icon icon="close"></b-icon>
            </div>
            <div class="section">
                <h4 class="title">{{ $t("Request address") }}</h4>
                <div class="body">
                    <p>{{ $t("Please enter your friend or client info") }}</p>
                </div>

                <form @submit.prevent>
                    <div
                        :class="[
                            'custom-input',
                            form.name.length > 6 ? 'active' : '',
                        ]"
                    >
                        <input
                            :placeholder="$t('Your friend or client full name')"
                            name="name"
                            v-model="form.name"
                            :required="true"
                            :maxlength="44"
                        />
                        <img
                            v-if="form.name.length > 6"
                            src="@/assets/images/CHECK-Mark.svg"
                            style="width: 15px"
                        />
                    </div>
                    <div
                        :class="[
                            'custom-input',
                            form.email.length > 6 ? 'active' : '',
                        ]"
                    >
                        <input
                            :placeholder="$t('Your friend or client Email')"
                            name="email"
                            v-model="form.email"
                            :required="true"
                            :maxlength="44"
                        />
                        <img
                            v-if="form.email.length > 6"
                            src="@/assets/images/CHECK-Mark.svg"
                            style="width: 15px"
                        />
                    </div>

                    <div class="btn">
                        <button class="button">
                            <span>{{ $t("Send") }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                name: "",
                email: "",
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.modal-add-address {
    width: 100%;
    text-align: center;
    img {
        position: absolute;
        top: 3px;
        right: 0;
        &:lang(ar) {
            right: auto !important;
            left: 0;
        }
    }

    .main-modal {
        position: relative;
        display: inline-block;
        background-color: white;
        width: 945px;
        min-height: 600px;
        border-radius: 15px;
    }

    .close {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }
    .body {
        margin-top: 80px;
        text-align: left;
        &:lang(ar) {
            text-align: right !important;
        }
        p {
            font-size: 20px;
            color: #777;
        }
    }
    form {
        margin-top: 80px;
        text-align: left;
        &:lang(ar) {
            text-align: right !important;
        }

        .btn {
            height: 100%;
            text-align: left;
            margin-top: 8em;
            button {
                background: #4952ff;
                color: white;
                border: none;
                width: 35%;
            }
        }
    }

    .custom-input {
        position: relative;
        display: inline-block;
        // border-bottom: 2px solid #9b9b9b;
        margin-bottom: 25px;
        width: 55%;
        &.active {
            border-color: #4bcaae;
        }

        input {
            width: 100%;
            border-radius: 10px;
            color: #444444;
            font-size: 1em;
            font-weight: 100 !important;
            -webkit-transition: 0.25s ease-out;
            transition: 0.25s ease-out;
            display: inline-block;
            border: 0 !important;
            background: #f2f2f2;
            padding: 13px;
        }
    }
}
</style>
